import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import { CardModel } from "../../../swagger/api.client.generated";
import { CardExpandedComponent } from "./card-expanded.component";

/** A card's larger view opened - `closed$` fires when it closes. */
export interface CardExpandedEvent {
  card: CardModel;
  closed$: Observable<unknown>;
}

@Injectable({ providedIn: "root" })
export class CardExpandService {
  private readonly openedSub = new Subject<CardExpandedEvent>();

  /**
   * Fires each time a card's larger view opens. The saved-Plan walkthrough's UP04 / UP05 (FLIP-386)
   * complete on it: the expand icon is the real control, and the flip icon lives in this view.
   */
  readonly opened$: Observable<CardExpandedEvent> = this.openedSub.asObservable();

  constructor(private dialog: MatDialog) {}

  open(card: CardModel): MatDialogRef<CardExpandedComponent> {
    const ref = this.dialog.open(CardExpandedComponent, {
      id: "card-expanded",
      data: card,
      panelClass: "card-expanded-panel",
    });
    this.openedSub.next({ card, closed$: ref.afterClosed() });
    return ref;
  }
}
